import { Paper, withStyles, WithStyles } from '@material-ui/core';
import * as React from 'react';

const styles = {

}
type Props = WithStyles;

export class Support extends React.Component<Props, {}> {
	public render() {
		// const {theme} = this.props;
		return (
			<Paper color={'secondary'} style={{color: '#f8f8f8', width: `${700}px`, background: `linear-gradient(to right, rgba(11, 11, 11, .8), rgba(11, 11, 11, 1) ${700 / 2}px, rgba(11, 11, 11, .8) ${700}px)`, backgroundSize: `${700}px 100%`, backgroundPosition: '50% 100%', backgroundRepeat: 'no-repeat', margin: '10px auto'}}>
				<div style={{margin: '25px'}}>
					<h2>Support</h2>
					
				</div>
			</Paper>
		);
	}
}

export default withStyles(styles)(Support);


// WEBPACK FOOTER //
// ./src/components/Support.tsx